export default __webpack_public_path__ + "static/media/Tunic of the Precursor.cd854129.jpg";